import { WelcomeHeader } from '../components/WelcomeHeader'
import { WorkflowSummaries } from '../components/WorkflowSummaries'
import { AdminShortcutPanel } from '../components/AdminShortcutPanel'

export function WelcomePage() {
  return (
    <main className="container mx-auto space-y-8 py-8">
      <WelcomeHeader />
      <AdminShortcutPanel />
      <WorkflowSummaries />
    </main>
  )
}
